module.exports = __webpack_public_path__ + "img/0Q3A6453_L_WoodMatted.8fd094d5.jpg";